export default function Subtract(props: any) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0ZM9.2926 13.7581L13.9382 10.4054C14.2147 10.2059 14.2147 9.79413 13.9382 9.59456L9.2926 6.24188C8.96192 6.00324 8.5 6.23952 8.5 6.64733V13.3527C8.5 13.7605 8.96192 13.9968 9.2926 13.7581Z"
                fill="black"
            ></path>
        </svg>
    );
}
